export const setEmailInLocalStorage = (email: string): void => {
  if (typeof window !== "undefined") {
    localStorage.setItem("userEmail", email);
  }
};

export const getEmailFromLocalStorage = (): string | undefined => {
  if (typeof window !== "undefined") {
    const email = localStorage.getItem("userEmail");
    return email ? email : undefined;
  }
  return undefined;
};

export const setTokenInLocalStorage = (token: string): void => {
  if (typeof window !== "undefined") {
    localStorage.setItem("token", token);
  }
};

export const getTokenFromLocalStorage = (): string | null => {
  if (typeof window !== "undefined") {
    return localStorage.getItem("token");
  }
  return null;
};

export const removeTokenFromLocalStorage = (): void => {
  if (typeof window !== "undefined") {
    localStorage.removeItem("token");
  }
};

export const setUserDataInLocalStorage = (userData: any): void => {
  if (typeof window !== "undefined") {
    // Convert the userData object to a JSON string
    const userDataJson = JSON.stringify(userData);
    // Store the JSON string in localStorage under the key "userData"
    localStorage.setItem("userData", userDataJson);
  }
};

export const getUserDataFromLocalStorage = (): any | null => {
  if (typeof window !== "undefined") {
    // Retrieve the userData JSON string from localStorage
    const userDataJson = localStorage.getItem("userData");
    if (userDataJson) {
      // Parse the JSON string back into an object and return it
      return JSON.parse(userDataJson);
    }
  }
  return null; // Return null if window or localStorage is not available
};

export const removeUserDataFromLocalStorage = (): void => {
  if (typeof window !== "undefined") {
    localStorage.removeItem("userData");
  }
};
